import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/pages/HomePage';
import UserLayout from './components/layout/UserLayout';
import './App.css';


import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import OthersLayout from './components/othersLayout/OthersLayout';
import Disclaimer from './components/pages/Disclaimer';
import ParkHeightsLayout from './components/parkHeightsLayout/ParkHeightsLayout';
import ParkHeightsPage from './components/pages/ParkHeightsPage';
import CosmosLayout from './components/cosmosLayout/CosmosLayout';
import CosmosPage from './components/pages/CosmosPage';
import MangalaLayout from './components/mangalaLayout/MangalaLayout';
import MangalaPage from './components/pages/MangalaPage';
import CursorFollower from './components/pages/CursorFollower';
import ThankYouPage from './components/pages/ThankYouPage';
// Import JourneyPage here later

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <CursorFollower/>
      <Routes>
        {/* Default Site Layout */}
        <Route element={<UserLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
        </Route>

        {/* General Pages */}
        <Route element={<OthersLayout />}>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Route>

        {/* Specific Project Pages with their Layouts */}
        <Route path="/cpr-park-heights" element={<ParkHeightsLayout />}>
          <Route index element={<ParkHeightsPage />} />
        </Route>

        <Route path="/cpr-cosmos" element={<CosmosLayout />}>
          <Route index element={<CosmosPage />} />
        </Route>

        <Route path="/cpr-mangala" element={<MangalaLayout />}>
          <Route index element={<MangalaPage />} />
        </Route>

        {/* Standalone Thank You Pages */}
        <Route path="/cpr-park-heights/thank-you" element={<ThankYouPage />} />
        <Route path="/cpr-cosmos/thank-you" element={<ThankYouPage />} />
        <Route path="/cpr-mangala/thank-you" element={<ThankYouPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;